import { combineClass, type JSX } from 'cdui-js';
import './ButtonItem.css';
import type { DiFiCheckBoxItemProps } from './types';
import { bindActivate, resolveLabel, rootA11y } from './shared';

function buttonColorVars(defaultColor?: string, activeColor?: string): JSX.CSSProperties {
  const v: Record<string, string> = {};
  if (defaultColor) v['--difi-cb-btn-bg'] = defaultColor;
  if (activeColor) {
    v['--difi-cb-btn-active-bg'] = activeColor;
    v['--difi-cb-btn-active-border'] = activeColor;
  }
  return v as JSX.CSSProperties;
}

/** 按钮块多选（原 segment） */
export const ButtonItem = (props: DiFiCheckBoxItemProps) => {
  const activate = bindActivate(props.itemProps);
  const a11y = rootA11y(props.itemProps);
  const rootStyle: JSX.CSSProperties = {
    ...buttonColorVars(props.itemProps.defaultColor, props.itemProps.activeColor),
    ...props.itemProps.style,
  };

  return (
    <div
      class={combineClass(
        'difi-checkbox-button',
        props.itemProps.checked === true && 'difi-checkbox-button--active',
        props.itemProps.disabled === true && 'difi-checkbox-button--disabled',
        props.itemProps.class,
      )}
      style={rootStyle}
      {...a11y}
      {...activate}
    >
      {resolveLabel(props.itemProps, 'difi-checkbox-button__label', true)}
    </div>
  );
};
